import BodyText from "components/Typography/BodyText"
import Heading from "components/Typography/Heading"
import { TabsContext } from "components/EvtKit/tabs/Tabs"
import { List } from "hooks/useHandleObjList"
import { PricingUnits, tabIds } from "pages/purchase-plans/constants/defaultValues"
import { IDevModePricingVariables } from "pages/purchase-plans/hooks/usePurchasePlan"

import ConsumptionSummary from "./summary/ConsumptionSummary"
import DevModeSummary from "./summary/DevModeSummary"
import MonthlySummary from "./summary/MonthlySummary"

import { memo, useContext } from "react"
import styled from "styled-components"

const SummaryContainer = styled.div`
  width: 324px;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background-color: ${(props) => props.theme.palette.white};
  padding: 16px;
  box-shadow: 0px 2px 6px 0px #0000001a;
  gap: 24px;
`

const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const Divider = styled.div`
  border: 1px solid ${(props) => props.theme.palette.disabled};
  width: 292px;
`

const ResultContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`

interface PlanSummaryProps {
  planName: string
  isDevMode: boolean
  fromPriceUnit?: string
  selectedProduct: string
  pricingCalculator?: IDevModePricingVariables
  fromPrice?: string
  pricingUnit?: PricingUnits
  pricingVariablesList: List<App.ISimplePricingVariable>
  isUpdate?: boolean
  initialData?: App.IPurchasePlanPayload
}

const PlanSummary = (props: PlanSummaryProps) => {
  const {
    planName,
    isDevMode,
    fromPriceUnit = "",
    selectedProduct,
    pricingCalculator,
    pricingUnit,
    fromPrice,
    pricingVariablesList,
    isUpdate = false,
    initialData
  } = props

  const { activeTabId } = useContext(TabsContext)

  return (
    <>
      {activeTabId === tabIds.plans && (
        <SummaryContainer>
          <TitleContainer>
            <Heading variant="h5">Resumo</Heading>
            <Divider />
          </TitleContainer>

          {!!planName && (
            <Heading variant="h6" color="primary-dark">
              {planName}
            </Heading>
          )}

          {isDevMode && (
            <DevModeSummary
              isDevMode={isDevMode}
              fromPriceUnit={fromPriceUnit ?? ""}
              selectedProduct={selectedProduct}
              pricingCalculator={pricingCalculator}
            />
          )}

          {!isDevMode && (
            <>
              {!pricingUnit && (
                <ResultContainer>
                  <BodyText color="gray-medium" weight="semi-bold">
                    Para gerar o resumo, preencha os campos em definições para precificação.
                  </BodyText>
                </ResultContainer>
              )}

              {pricingUnit === PricingUnits.MONTHLY && (
                <MonthlySummary
                  pricingUnit={pricingUnit}
                  selectedProduct={selectedProduct}
                  fromPrice={fromPrice}
                  pricingVariablesList={pricingVariablesList}
                />
              )}

              {pricingUnit === PricingUnits.CONSUMPTION && (
                <ConsumptionSummary
                  isDevMode={isDevMode}
                  fromPriceUnit={fromPriceUnit ?? ""}
                  selectedProduct={selectedProduct}
                  pricingUnit={pricingUnit}
                  pricingVariablesList={pricingVariablesList}
                  isUpdate={isUpdate}
                  initialData={initialData}
                />
              )}
            </>
          )}
        </SummaryContainer>
      )}
    </>
  )
}

export default memo(PlanSummary)
